import React from 'react'
import { BooleanInput } from 'react-admin'
import { OptionItem } from 'services/api/entities/catalog/optionedProduct/types/internal/optionedProduct-models'
import { STANDARD_PRICING_STARTUP } from 'services/cfg/form'
import {
  ArrayInputContentProps,
  useKArrayInput,
} from 'services/hooks/useKArrayInput'
import StandardPricingInput from './standard/StandardPricingInput'

type Props = ArrayInputContentProps

const CatalogOptionsPricingInput: React.FC<Props> = ({ source }) => {
  const { scopedFormData: optionItem, kGetSource } = useKArrayInput<OptionItem>(
    source!
  )

  if (optionItem.isPriced && !optionItem.pricing?.length) {
    optionItem.pricing = STANDARD_PRICING_STARTUP
  }

  return (
    <>
      <BooleanInput
        source={kGetSource!('isPriced')}
        label="form.fields.pricing"
      />
      {optionItem.isPriced && (
        <StandardPricingInput source={kGetSource!('pricing')} />
      )}
    </>
  )
}

export default CatalogOptionsPricingInput
